import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

// iter87.199.31 — Public-facing wrong-URL fallback. Only surfaces
// the routes a real visitor would legitimately want: the rivalry
// landing and the Pro+ sign-in. Internal admin surfaces (Site Admin,
// Commons Console, Mobile Stand-In) were leaking here and have been
// removed — those admins already know their direct URLs.
const DESTINATIONS = [
    { to: "/", label: "Home — rivalry landing" },
    { to: "/rivalry-pro/login", label: "Rivalry Pro+ sign-in" },
];

export default function NotFound() {
    return (
        <div className="min-h-screen bg-ink text-white flex items-center justify-center p-6" data-testid="not-found-page">
            <div className="brutal-card p-8 max-w-md w-full space-y-4">
                <h1 className="font-display font-extrabold text-2xl uppercase tracking-tight flex items-center gap-2">
                    <Compass className="w-6 h-6 text-volt" /> No page here
                </h1>
                <p className="text-sm text-zinc-400">
                    That URL doesn't exist. Here's where you probably meant to go:
                </p>
                <div className="space-y-2">
                    {DESTINATIONS.map((d) => (
                        <Link key={d.to} to={d.to} data-testid={`not-found-link-${d.to.replace("/", "") || "home"}`}
                              className="block brutal-btn-ghost text-sm py-2 px-3 text-left">
                            {d.label}
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}
